import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  tableOverflow: {
    overflow: 'auto'
  },
  tableWidget: {
    overflowX: "auto",
  },
  input: {
    border: '0px',
    backgroundColor: "#FFFFFF",
    padding: '12px',
    width: '350px',
    borderRadius: '100px',
    outlineColor: "#FFFFFF"
  },
  divHeader: {
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    marginBottom: '24px',
  },
  searchDivFullWidthWithoutShadow: {
    height: '60px',
    width: '100%',
    backgroundColor: "#FFFFFF",
    padding: '6px',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '4px',
  },
  inputSearchFull: {
    border: '0px',
    backgroundColor: "#FFFFFF",
    borderRadius: '4px',
    padding: '12px',
    width: '100%',
    outlineColor: "#FFFFFF"
  },
  div: {
    height: '50px',
    width: '410px',
    backgroundColor: "#FFFFFF",
    padding: '6px',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
    boxShadow: theme.customShadows.widgetBlack,
  },
  divSearch: {
    height: '50px',
    width: '53px',
    padding: '2px',
    borderRadius: '100px',
    backgroundColor: "#FFFFFF",
    color: "#000000",
  },
  divAddButton: {
    height: '50px',
    width: '50px',
    backgroundColor: "#FFFFFF",
    marginLeft: '24px',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
    boxShadow: theme.customShadows.widgetBlack,
  },
  searchIcon: {
    borderRadius: '100px',
    padding: '8px',
    height: '100%',
    width: '100%',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    color: "#000000",
    transition: theme.transitions.create("right"),
    "&:hover, &:focus": {
      cursor: "pointer",
      backgroundColor: "#F4F4F4",
      color: "#000000"
    }
  },
  searchIconProduct: {
    borderRadius: '100px',
    padding: '4px',
    height: '100%',
    width: '100%',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    color: "#000000",
    transition: theme.transitions.create("right"),
    "&:hover, &:focus": {
      cursor: "pointer",
      backgroundColor: "#F4F4F4",
      color: "#000000"
    }
  },
  divTitle: {
    width: "100%",
    display: "flex",
    marginTop: "12px",
    marginLeft: "12px",
    marginBottom: "24px",
  },
  titleStyle: {
    fontWeight: '500',
    fontSize: "28px",
    color: "#FFFFFF",
  },
  divSeparate: {
    marginBottom: "50px"
  },
  green: {
    backgroundColor: theme.palette.green.main,
    color: '#fff',
  },
  yellow: {
    backgroundColor: theme.palette.yellow.main,
    color: '#fff',
  },
  gray: {
    backgroundColor: theme.palette.gray.main,
    color: '#fff',
  },
  red: {
    backgroundColor: theme.palette.red.main,
    color: '#fff',
  },
  divAddPage: {
    backgroundColor: "#000000",
    padding: '16px',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '4px',
    boxShadow: theme.customShadows.widgetBlack,
  },
  divButton: {
    width: "100%",
    display: "flex",
    justify: "center",
    alignItems: "center",
    marginTop: "100px",
    marginBottom: "24px",
  },
  disableButton: {
    backgroundColor: "#F4F4F4",
    color: "#C9C9C9",
    fontSize: "20px",
    padding: "12px 60px",
    borderRadius: '6px',
    margin: "auto",
    borderWidth: "0px"
  },
  enableButton: {
    backgroundColor: "#FFFFFF",
    color: "#000000",
    fontSize: "20px",
    padding: "12px 60px",
    borderRadius: '6px',
    margin: "auto",
    cursor: 'pointer',
    borderWidth: "0px",
    boxShadow: theme.customShadows.widgetBlack,
  },
  divColumn: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
    ['@media (max-width:800px)']: {
      gridTemplateColumns: '1fr',
    },
    marginBottom: "24px",
  },
  divThreeColumns: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: '20px',
    ['@media (max-width:800px)']: {
      gridTemplateColumns: '1fr',
    },
    marginBottom: "24px",
  },
  inputText: {
    backgroundColor: "#FFFFFF",
    padding: '8px',
    width: '85%',
    fontSize: '18px',
  },
  textBorder: {
    "&:before": {
      borderBottomColor: '2px solid #F4F4F4'
    },
    "&:after": {
      borderBottomColor: '2px solid #000000'
    },
    "&:hover:before": {
      borderBottomColor: '2px solid #000000',
    },
  },
  label: {
    display: 'block',
    fontWeight: '500',
    padding: '10px',
    minHeight: '40px',
    color: "#FFFFFF",
  },
  formControl: {
    width: '85%',
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  loginLoader: {
    display: "flex",
    justify: "center",
    alignItems: "center",
    margin: "auto"
  },
  textFieldTime: {
    width: '70%',
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
    marginBottom: "24px",
  },
  indeterminateColor: {
    color: "#f50057"
  },
  selectAllText: {
    fontWeight: 500
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)"
    }
  },
  footerTable: {
    marginTop: "60px",
    marginLeft: "24px",
    marginRight: "24px",
    display: 'flex',
    flexDirection: 'row',
    float: "right",
  },
  footerTableFirstDiv: {
    display: "flex",
    float: "left",
    alignItems: 'center',
  },
  footerTableSecondDiv: {
    display: "flex",
    float: "right",
    alignItems: 'center',
  },
  footerText: {
    fontSize: "16px",
    color: "#FFFFFF",
    marginRight: "24px",
  },
  spaceBetweenButtons: {
    marginRight: "20px",
  },
  buttonPageEnable: {
    border: "solid",
    borderWidth: "1px",
    borderColor: "#EBEBEB",
    borderRadius: '4px',
    cursor: "pointer",
    padding: "8px 20px",
    backgroundColor: "#FFFFFF",
    justify: 'center',
    alignItems: 'center',
    fontSize: "13px",
  },
  buttonPageDisable: {
    border: "solid",
    borderWidth: "1px",
    borderColor: "#EBEBEB",
    borderRadius: '4px',
    padding: "8px 20px",
    backgroundColor: "#F4F4F4",
    color: "#C9C9C9",
    justify: 'center',
    alignItems: 'center',
    fontSize: "13px",
  },
  headerTableStyle: {
    marginTop: "20px",
    marginBottom: "20px",
    width: "100%",
  },
  tableTextStyle: {
    color: "#FFFFFF",
    fontSize: "16px",
    borderBottom: 'none',
  },
  tableTextStyleInvert: {
    color: "#000",
    fontSize: "16px",
    borderBottom: 'none',
  },
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      marginTop: "20px",
      marginBottom: "20px",
      fontSize: "16px",
      borderBottom: 'none',
    },
  },
  rootInvert: {
    "& .MuiTableCell-head": {
      color: "black",
      marginTop: "20px",
      marginBottom: "20px",
      fontSize: "16px",
      borderBottom: 'none',
    },
  },
  rowWithHover: {
    transition: theme.transitions.create("right"),
    "&:hover, &:focus": {
      cursor: "pointer",
      backgroundColor: "#F4F4F4",
      color: "#000000"
    }
  },
  buttonPageEnableArrow: {
    color: theme.palette.red.main,
    cursor: "pointer",
    padding: '4px',
    height: '100%',
    width: '100%',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
    marginLeft: "3px",
  },
  buttonPageEnableArrowForward: {
    color: theme.palette.red.main,
    cursor: "pointer",
    padding: '4px',
    height: '100%',
    width: '100%',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
  },
  buttonPageEnableArrowDiv: {
    height: "30px",
    width: "30px",
    border: "solid",
    borderWidth: "1px",
    borderColor: theme.palette.red.main,
    borderRadius: '100px',
    display: "flex",
    justify: "center",
    alignItems: "center",
  },
  buttonPageDisableArrow: {
    color: "#7E1E1E",
    cursor: "pointer",
    padding: '4px',
    height: '100%',
    width: '100%',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
    marginLeft: "3px",
  },
  buttonPageDisableArrowForward: {
    color: "#7E1E1E",
    cursor: "pointer",
    padding: '4px',
    height: '100%',
    width: '100%',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
  },
  buttonPageDisableArrowDiv: {
    height: "30px",
    width: "30px",
    border: "solid",
    borderWidth: "1px",
    borderColor: "#7E1E1E",
    borderRadius: '100px',
    display: "flex",
    justify: "center",
    alignItems: "center",
  },
  divCard: {
    backgroundColor: "#000000",
    padding: '16px',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '4px',
    boxShadow: theme.customShadows.widgetBlack,
  },
  inputSearch: {
    border: '0px',
    backgroundColor: "#FFFFFF",
    borderRadius: '100px',
    padding: '12px',
    width: '350px',
    outlineColor: "#FFFFFF"
  },
  divActionButton: {
    height: '40px',
    width: '40px',
    backgroundColor: "#FFFFFF",
    marginLeft: '20px',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    borderRadius: '100px',
    boxShadow: theme.customShadows.widgetBlack,
  },
  iconAcctionInventory: {
    borderRadius: '100px',
    padding: '8px',
    height: '100%',
    width: '100%',
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    color: "#000000",
    transition: theme.transitions.create("right"),
    "&:hover, &:focus": {
      cursor: "pointer",
      backgroundColor: "#F4F4F4",
      color: "#000000"
    }
  },
  inputDescription: {
    backgroundColor: "#000000",
    color: "#FFFFFF",
    padding: '8px',
    width: '85%',
    height: '200px',
    fontSize: '16px',
  },
  divSwitch: {
    display: 'flex',
    justify: 'center',
    alignItems: 'center',
    paddingLeft: '8px',
  },
  inputForm: {
    backgroundColor: "#000000",
    color: "#FFFFFF",
    padding: '8px',
    width: '85%',
    fontSize: '18px',
  },
  textBorderEntry: {
    "&:before": {
      borderBottomColor: '2px solid #FFFFFF'
    },
    "&:after": {
      borderBottomColor: '2px solid #000000'
   },
    "&:hover:before": {
      borderBottomColor: '2px solid #000000'
    },
  },
  inputEntry: {
    backgroundColor: "#000000",
    color: "#FFFFFF",
    padding: '8px',
    width: '100%',
    fontSize: '18px',
    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  labelTitle: {
    display: 'flex',
    fontWeight: '500',
    fontSize: '20px',
    color: "#FFFFFF",
  },
  inputNumber: {
    backgroundColor: "#000000",
    color: "#FFFFFF",
    padding: '8px',
    width: '100%',
    fontSize: '18px',
    textAlign: 'center',
    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  inputNumberPurchase: {
    backgroundColor: "#000000",
    color: "#FFFFFF",
    padding: '8px',
    width: '70%',
    fontSize: '18px',
    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  textPurchase: {
    float: "right",
    textAlign: "right",
    width: "100%",
    fontSize: "16px"
  },
  snackbarStyleViaContentProps: {
    backgroundColor: "green"
  },
  snackbarStyleViaContentPropsError: {
    backgroundColor: "red"
  },
  centerTextStyle: {
    color: "#FFFFFF",
    fontSize: "14px",
    textAlign: "center",
    borderBottom: 'none',
  },
}));
